/*
 * @Author: ≡Christine 1204356932@qq.com
 * @Date: 2024-10-15 11:25:33
 * @LastEditors: ≡Christine 1204356932@qq.com
 * @LastEditTime: 2024-11-14 18:30:31
 * @FilePath: \management-portal\src\router\guard\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { Router } from 'vue-router';
import NProgress from '@/utils/nprogress';
import { useUserStore, useRouteStore } from '@/store';
import { t } from '@/hooks/useI18n';

const whiteList = ['/login', '/miniOpen'];
/**
 * 路由守卫函数
 * @param router - 路由实例
 */
export function createRouterGuard(router: Router) {
  const userStore = useUserStore();
  const routeStore = useRouteStore();
  router.beforeEach(async (to, from, next) => {
    NProgress.start();
    // 访问登录页，有token不做跳转，没有跳转登录页
    if (to.path === '/login') {
      if (userStore.isLogin) return next(from.fullPath);
      return next();
    }
    // 白名单放行
    if (whiteList.includes(to.path)) return next();

    // token不存在，跳登录页
    if (!userStore.isLogin) return next({ path: '/login', query: { redirect: to.fullPath } });

    // 未初始化路由，等待执行
    if (!routeStore.isInitRoute) {
      routeStore.initRoute();
      return next({ path: to.fullPath, replace: true, query: to.query, hash: to.hash });
    }

    // 匹配到未知路径,跳404
    if (to.name === 'not-found') return next({ path: '/error' });

    // 默认放行
    next();
  });

  router.afterEach((to, from, next) => {
    if (to.query.title) {
      to.meta.title = to.query.title;
    }
    NProgress.done();
  });
}
